import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import './style.scss';

const Spinner = ({ className, isWhite, isBlue, isOrange, isThin }) => (
  <i
    styleName={cn('spinner', {
      'is-white': isWhite,
      'is-blue': isBlue,
      'is-orange': isOrange,
      'is-thin': isThin,
    })}
    className={className}
    data-test="spinner"
  />
);

Spinner.propTypes = {
  className: PropTypes.string,
  isBlue: PropTypes.bool,
  isWhite: PropTypes.bool,
  isOrange: PropTypes.bool,
  isThin: PropTypes.bool,
};

Spinner.defaultProps = {
  className: '',
  isBlue: false,
  isWhite: false,
  isOrange: false,
  isThin: false,
};

export default Spinner;
